import { useDispatch } from "react-redux";
import { addUserDetails, selectAuth } from "features/auth/AuthSlice";
import { useWhatsAppListener } from "components/WebConnector/WhatsApp/webSocket/useWhatsAppListener";
import CustomNotify from "components/common/atoms/CustomNotify";
import { useSelector } from "react-redux";
import WhatsappIcon from "static/images/WhatsappIcon";
import { t } from "components/CentralDataMangement/translation/Translation";

export const InstanceStatusListener = () => {
  const dispatch = useDispatch();
  const authUser = useSelector(selectAuth);

  const handleInstanceStatusChange = (data: any) => {
    const status = data?.status === "1" || data?.status === 1;
    const statusType = status ? "success" : "error";
    const msg = status
      ? "Instance connected successfully"
      : "Instance disconnected. Please check with the admin";
    if (status) {
      CustomNotify({ type: statusType, message: msg });
    }
    dispatch(addUserDetails({ isInstanceReady: status }));
  };

  const handleListenerMessage = (data: any) => {
    const loggedInUserId = authUser.userId;

    if (data.userId === loggedInUserId) {
      CustomNotify({
        type: "success",
        message: (
          <div className="d-flex align-items-center whatsapp-toaster">
            <div className="table-action-icons position-relative d-inline-block me-2">
              <WhatsappIcon />
            </div>
            <div>
              {t("New whatsapp message from ")}
              <strong>{data.senderName}</strong>
            </div>
          </div>
        ),
      });
    }
  };

  useWhatsAppListener({
    "instance.status.changed": handleInstanceStatusChange,
    "notify.user": handleListenerMessage,
  });

  return null; // no UI needed
};
